<div class="informative">
    <div class="p-row">
      <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 po-clickable" p-primary-label="+ Detalhes"
        p-title="Defeito dia atual" [p-tooltip]="itemTotalDefectDayTooltip">
        <div class="icon-loading" *ngIf="loading">
          <app-loading-icon></app-loading-icon>
        </div>
        <div class="po-font-subtitle po-text-center" *ngIf="!loading">
          <span *ngIf="itemTotalDefectDayValidation != null">{{itemTotalDefectDay || "0"}}</span>
          <span class="po-font-text-large" *ngIf="itemTotalDefectDayValidation != null">%</span>
          <span *ngIf="itemTotalDefectDayValidation == null">
            <span class="po-icon po-icon-exclamation"></span>
          </span>
        </div>
      </po-widget>
      <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 po-clickable" p-primary-label="+ Detalhes" p-title="Defeito semana atual"
        [p-tooltip]="itemTotalDefectWeekTooltip">
        <div class="icon-loading" *ngIf="loading">
          <app-loading-icon></app-loading-icon>
        </div>
        <div class="po-font-subtitle po-text-center" *ngIf="!loading">
          <span *ngIf="itemTotalDefectWeekValidation != null">{{itemTotalDefectWeek || "0"}}</span>
          <span class="po-font-text-large" *ngIf="itemTotalDefectWeekValidation != null">%</span>
          <span *ngIf="itemTotalDefectWeekValidation == null">
            <span class="po-icon po-icon-exclamation"></span>
          </span>
        </div>
      </po-widget>
      <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 po-clickable" p-primary-label="+ Detalhes" p-title="Defeito mês atual"
        [p-tooltip]="itemTotalDefectMonthTooltip">
        <div class="icon-loading" *ngIf="loading">
          <app-loading-icon></app-loading-icon>
        </div>
        <div class="po-font-subtitle po-text-center" *ngIf="!loading">
          <span *ngIf="itemTotalDefectMonthValidation != null">{{itemTotalDefectMonth || "0"}}</span>
          <span class="po-font-text-large" *ngIf="itemTotalDefectMonthValidation != null">%</span>
          <span *ngIf="itemTotalDefectMonthValidation == null">
            <span class="po-icon po-icon-exclamation"></span>
          </span>
        </div>
      </po-widget>
      <po-widget class="po-lg-3 po-md-3 po-sm-6 po-mt-2 po-clickable" p-primary-label="+ Detalhes" p-title="Qt. Finalização Total"
        p-tooltip="Data: {{dataLabel}}">
        <div class="icon-loading" *ngIf="loading">
          <app-loading-icon></app-loading-icon>
        </div>
        <div class="po-font-subtitle po-text-center" *ngIf="!loading">
          <span *ngIf="itemTotalFinValidation != null">{{itemTotalFin || "0"}}</span>
          <span *ngIf="itemTotalFinValidation == null">
            <span class="po-icon po-icon-exclamation"></span>
          </span>
        </div>
      </po-widget>
    </div>
  </div>
